import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { WithAuth } from "@/hoc";
import { Button, Flex, Grid, useMediaQuery, Icon } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Alert } from "@/components";
import { PunctualCharge } from "./punctual-charge";
import PreviewLinkPagamento from "@/components/PreviewLinkPagamento";
import { usePreviewContext } from "@/contexts/PreviewContext";
import { PageHeading } from "barte-design-system";
import { useNavigate } from "react-router-dom";

const SejaPago = () => {
  const { id } = useParams();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [successModalState, setSuccessModalState] = useState(false);
  const [createdUrl, setCreatedUrl] = useState("");
  const cancelRef = useRef(null);
  const { previewData, setPreviewData } = usePreviewContext();
  const navigate = useNavigate();
  const [isLargeScreen] = useMediaQuery('(min-width: 980px)');
  const [showButtonPreview] = useMediaQuery('(min-width: 1240px)');
  const showPreview = isPreviewOpen;

  useEffect(() => {
    if (isLargeScreen) {
      setIsPreviewOpen(true);
    } else {
      setIsPreviewOpen(false);
    }
  }, [isLargeScreen]);

  function handleSuccess(url: string) {
    setCreatedUrl(url);
    setSuccessModalState(true);
  }

  return (
    <Flex
      flexDir="column"
      align="start"
      pb="20px"
    >
      <Alert
        isConfirmAlert={true}
        isOpen={successModalState}
        onConfirm={() => { setSuccessModalState(false); navigate("/seja-pago"); }}
        onClose={() => setSuccessModalState(false)}
        title="Cobrança criada com sucesso"
        messageBody="Clique no link abaixo para copiar:"
        urlBody={createdUrl}
        leastDestructiveRef={cancelRef}
      />

      <PageHeading
      title="Seja Pago"
      onBack={() => navigate(-1)}
      />

      <Grid
        templateColumns={showPreview ? "1fr 323px" : "1fr"}
        gap="45px"
        h="80vh"
        w="100%"
        position="relative"
      >
        <Flex
          pr={showPreview ? "20px" : "0"}
          flexDir="column"
          overflowY="scroll"
          position="sticky"
          top="0"
          alignItems="center"
          css={{
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none'
          }}
          marginRight="45px"
        >
          <Flex w="100%" maxW={{ base: "100%", xl: "820px" }} mx="auto">
            <PunctualCharge
              punctualButton={true}
              setPreviewData={setPreviewData}
              previewData={previewData}
              setPunctualButton={() => {}}
              onSuccess={handleSuccess}
            />
          </Flex>
        </Flex>
        {!showButtonPreview &&
          <Button
            position="fixed"
            right={showPreview ? "415px" : "20px"}
            top="50%"
            transform="translateY(-50%)"
            zIndex="20"
            size="sm"
            variant="outline"
            bg="white"
            borderColor="gray.300"
            onClick={() => setIsPreviewOpen(!isPreviewOpen)}
            transition="all 0.3s ease"
            minW="40px"
            h="40px"
            borderRadius="50%"
            _hover={{
              bg: "gray.50",
              borderColor: "gray.400"
            }}
          >
            <Icon
              as={showPreview ? ChevronRightIcon : ChevronLeftIcon}
              w={4}
              h={4}
            />
          </Button>
        }

        {showPreview && (
          <Flex
            position="fixed"
            right="107px"
            top="70px"
            w="323px"
            flexDir="column"
            bg="white"
            h="100vh"
            zIndex="10"
            borderLeft={isLargeScreen ? "none" : "1px solid #E0E0E0"}
          >
            <PreviewLinkPagamento previewData={previewData} isPontual={true} />
          </Flex>
        )}
      </Grid>
    </Flex>
  );
};

export default WithAuth(SejaPago);
